module.exports = __webpack_public_path__ + "img/charmed-dndcompendium.7aaad870.jpg";